@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(-2_031_324_477)
internal val Res.string.rmp_type_requisicao: StringResource by lazy {
      StringResource("string:rmp_type_requisicao", "rmp_type_requisicao", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92376, 43),
      ))
    }

@delegate:ResourceContentHash(-66_857_168)
internal val Res.string.rmp_type_requisicao_teste: StringResource by lazy {
      StringResource("string:rmp_type_requisicao_teste", "rmp_type_requisicao_teste", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92314, 61),
      ))
    }

@delegate:ResourceContentHash(-1_690_553_575)
internal val Res.string.rmp_type_termino_contrato: StringResource by lazy {
      StringResource("string:rmp_type_termino_contrato", "rmp_type_termino_contrato", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92420, 61),
      ))
    }

@delegate:ResourceContentHash(551_519_760)
internal val Res.string.rmp_type_transferencia: StringResource by lazy {
      StringResource("string:rmp_type_transferencia", "rmp_type_transferencia", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92482, 50),
      ))
    }

@delegate:ResourceContentHash(1_748_974_040)
internal val Res.string.rmp_unit_rules: StringResource by lazy {
      StringResource("string:rmp_unit_rules", "rmp_unit_rules", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93093, 46),
      ))
    }

@delegate:ResourceContentHash(1_476_301_206)
internal val Res.string.rmp_unit_rules_hint: StringResource by lazy {
      StringResource("string:rmp_unit_rules_hint", "rmp_unit_rules_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92533, 291),
      ))
    }

@delegate:ResourceContentHash(1_175_377_156)
internal val Res.string.rmp_unit_rules_only_marked: StringResource by lazy {
      StringResource("string:rmp_unit_rules_only_marked", "rmp_unit_rules_only_marked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92825, 78),
      ))
    }

@delegate:ResourceContentHash(-1_450_442_755)
internal val Res.string.rmp_unit_rules_search: StringResource by lazy {
      StringResource("string:rmp_unit_rules_search", "rmp_unit_rules_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92904, 53),
      ))
    }

@delegate:ResourceContentHash(-1_457_371_750)
internal val Res.string.rmp_unit_rules_title: StringResource by lazy {
      StringResource("string:rmp_unit_rules_title", "rmp_unit_rules_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 92958, 64),
      ))
    }

@delegate:ResourceContentHash(1_554_762_765)
internal val Res.string.rmp_unit_rules_waives_ceo: StringResource by lazy {
      StringResource("string:rmp_unit_rules_waives_ceo", "rmp_unit_rules_waives_ceo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93023, 69),
      ))
    }

@delegate:ResourceContentHash(2_141_918_982)
internal val Res.string.shell_filters: StringResource by lazy {
      StringResource("string:shell_filters", "shell_filters", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93140, 33),
      ))
    }

@delegate:ResourceContentHash(-1_428_634_254)
internal val Res.string.slogan: StringResource by lazy {
      StringResource("string:slogan", "slogan", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93174, 70),
      ))
    }

@delegate:ResourceContentHash(-1_616_227_455)
internal val Res.string.users_action_activate: StringResource by lazy {
      StringResource("string:users_action_activate", "users_action_activate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93245, 37),
      ))
    }

@delegate:ResourceContentHash(-323_506_341)
internal val Res.string.users_action_create: StringResource by lazy {
      StringResource("string:users_action_create", "users_action_create", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93283, 35),
      ))
    }

@delegate:ResourceContentHash(-497_509_869)
internal val Res.string.users_action_deactivate: StringResource by lazy {
      StringResource("string:users_action_deactivate", "users_action_deactivate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93319, 43),
      ))
    }

@delegate:ResourceContentHash(-1_972_891_150)
internal val Res.string.users_action_details: StringResource by lazy {
      StringResource("string:users_action_details", "users_action_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93363, 40),
      ))
    }

@delegate:ResourceContentHash(-760_957_319)
internal val Res.string.users_action_edit: StringResource by lazy {
      StringResource("string:users_action_edit", "users_action_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93404, 33),
      ))
    }

@delegate:ResourceContentHash(2_669_562)
internal val Res.string.users_action_view: StringResource by lazy {
      StringResource("string:users_action_view", "users_action_view", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93438, 29),
      ))
    }

@delegate:ResourceContentHash(-1_616_227_949)
internal val Res.string.users_active: StringResource by lazy {
      StringResource("string:users_active", "users_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93468, 28),
      ))
    }

@delegate:ResourceContentHash(-682_883_532)
internal val Res.string.users_add: StringResource by lazy {
      StringResource("string:users_add", "users_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93497, 41),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.users_cancel: StringResource by lazy {
      StringResource("string:users_cancel", "users_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93539, 32),
      ))
    }

@delegate:ResourceContentHash(1_539_054_651)
internal val Res.string.users_col_actions: StringResource by lazy {
      StringResource("string:users_col_actions", "users_col_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93572, 37),
      ))
    }

@delegate:ResourceContentHash(1_326_493_253)
internal val Res.string.users_col_company: StringResource by lazy {
      StringResource("string:users_col_company", "users_col_company", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93610, 37),
      ))
    }

@delegate:ResourceContentHash(-957_383_799)
internal val Res.string.users_col_email: StringResource by lazy {
      StringResource("string:users_col_email", "users_col_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93648, 31),
      ))
    }

@delegate:ResourceContentHash(186_621_119)
internal val Res.string.users_col_full_name: StringResource by lazy {
      StringResource("string:users_col_full_name", "users_col_full_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93680, 47),
      ))
    }

@delegate:ResourceContentHash(1_998_825_050)
internal val Res.string.users_col_last_access: StringResource by lazy {
      StringResource("string:users_col_last_access", "users_col_last_access", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93728, 49),
      ))
    }

@delegate:ResourceContentHash(-1_406_265_798)
internal val Res.string.users_col_phone: StringResource by lazy {
      StringResource("string:users_col_phone", "users_col_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93778, 35),
      ))
    }

@delegate:ResourceContentHash(-1_317_222_191)
internal val Res.string.users_col_role: StringResource by lazy {
      StringResource("string:users_col_role", "users_col_role", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93814, 30),
      ))
    }

@delegate:ResourceContentHash(1_749_941_052)
internal val Res.string.users_col_sector: StringResource by lazy {
      StringResource("string:users_col_sector", "users_col_sector", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93845, 32),
      ))
    }

@delegate:ResourceContentHash(-1_720_241_764)
internal val Res.string.users_col_status: StringResource by lazy {
      StringResource("string:users_col_status", "users_col_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93878, 32),
      ))
    }

@delegate:ResourceContentHash(-1_049_962_070)
internal val Res.string.users_col_updated_at: StringResource by lazy {
      StringResource("string:users_col_updated_at", "users_col_updated_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93911, 56),
      ))
    }

@delegate:ResourceContentHash(-741_962_950)
internal val Res.string.users_col_updated_by: StringResource by lazy {
      StringResource("string:users_col_updated_by", "users_col_updated_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 93968, 44),
      ))
    }

@delegate:ResourceContentHash(-1_735_876_569)
internal val Res.string.users_company_hint: StringResource by lazy {
      StringResource("string:users_company_hint", "users_company_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94013, 102),
      ))
    }

@delegate:ResourceContentHash(-497_509_869)
internal val Res.string.users_deactivate_confirm: StringResource by lazy {
      StringResource("string:users_deactivate_confirm", "users_deactivate_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94116, 44),
      ))
    }

@delegate:ResourceContentHash(-400_816_871)
internal val Res.string.users_deactivate_msg: StringResource by lazy {
      StringResource("string:users_deactivate_msg", "users_deactivate_msg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94161, 92),
      ))
    }

@delegate:ResourceContentHash(-1_250_164_415)
internal val Res.string.users_deactivate_title: StringResource by lazy {
      StringResource("string:users_deactivate_title", "users_deactivate_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94254, 54),
      ))
    }

@delegate:ResourceContentHash(116_942_268)
internal val Res.string.users_details_title: StringResource by lazy {
      StringResource("string:users_details_title", "users_details_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94309, 55),
      ))
    }

@delegate:ResourceContentHash(-660_481_206)
internal val Res.string.users_empty: StringResource by lazy {
      StringResource("string:users_empty", "users_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94365, 55),
      ))
    }

@delegate:ResourceContentHash(-1_638_939_969)
internal val Res.string.users_export: StringResource by lazy {
      StringResource("string:users_export", "users_export", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94421, 32),
      ))
    }

@delegate:ResourceContentHash(-957_383_799)
internal val Res.string.users_field_email: StringResource by lazy {
      StringResource("string:users_field_email", "users_field_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94454, 33),
      ))
    }

@delegate:ResourceContentHash(186_621_119)
internal val Res.string.users_field_full_name: StringResource by lazy {
      StringResource("string:users_field_full_name", "users_field_full_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94488, 49),
      ))
    }

@delegate:ResourceContentHash(-1_155_375_975)
internal val Res.string.users_field_new_password: StringResource by lazy {
      StringResource("string:users_field_new_password", "users_field_new_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94538, 88),
      ))
    }

@delegate:ResourceContentHash(-114_784_899)
internal val Res.string.users_field_permissions: StringResource by lazy {
      StringResource("string:users_field_permissions", "users_field_permissions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94627, 47),
      ))
    }

@delegate:ResourceContentHash(-1_406_265_798)
internal val Res.string.users_field_phone: StringResource by lazy {
      StringResource("string:users_field_phone", "users_field_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94675, 37),
      ))
    }

@delegate:ResourceContentHash(-1_020_082_545)
internal val Res.string.users_field_profile: StringResource by lazy {
      StringResource("string:users_field_profile", "users_field_profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94713, 35),
      ))
    }

@delegate:ResourceContentHash(-1_317_222_191)
internal val Res.string.users_field_role: StringResource by lazy {
      StringResource("string:users_field_role", "users_field_role", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94749, 32),
      ))
    }

@delegate:ResourceContentHash(1_749_941_052)
internal val Res.string.users_field_sector: StringResource by lazy {
      StringResource("string:users_field_sector", "users_field_sector", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94782, 34),
      ))
    }

@delegate:ResourceContentHash(-682_883_532)
internal val Res.string.users_form_add_title: StringResource by lazy {
      StringResource("string:users_form_add_title", "users_form_add_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94817, 52),
      ))
    }

@delegate:ResourceContentHash(1_076_534_376)
internal val Res.string.users_form_edit_title: StringResource by lazy {
      StringResource("string:users_form_edit_title", "users_form_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94870, 49),
      ))
    }

@delegate:ResourceContentHash(148_263_877)
internal val Res.string.users_go_to_org_chart: StringResource by lazy {
      StringResource("string:users_go_to_org_chart", "users_go_to_org_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94920, 57),
      ))
    }

@delegate:ResourceContentHash(-1_156_291_138)
internal val Res.string.users_import: StringResource by lazy {
      StringResource("string:users_import", "users_import", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95784, 44),
      ))
    }

@delegate:ResourceContentHash(-1_233_152_142)
internal val Res.string.users_import_created: StringResource by lazy {
      StringResource("string:users_import_created", "users_import_created", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 94978, 60),
      ))
    }

@delegate:ResourceContentHash(-1_932_508_139)
internal val Res.string.users_import_duplicates: StringResource by lazy {
      StringResource("string:users_import_duplicates", "users_import_duplicates", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95039, 63),
      ))
    }

@delegate:ResourceContentHash(-2_134_511_786)
internal val Res.string.users_import_error: StringResource by lazy {
      StringResource("string:users_import_error", "users_import_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95103, 102),
      ))
    }

@delegate:ResourceContentHash(-1_107_503_376)
internal val Res.string.users_import_loaded: StringResource by lazy {
      StringResource("string:users_import_loaded", "users_import_loaded", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95206, 63),
      ))
    }

@delegate:ResourceContentHash(-329_813_040)
internal val Res.string.users_import_pick: StringResource by lazy {
      StringResource("string:users_import_pick", "users_import_pick", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95270, 53),
      ))
    }

@delegate:ResourceContentHash(-117_389_239)
internal val Res.string.users_import_previewing: StringResource by lazy {
      StringResource("string:users_import_previewing", "users_import_previewing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95324, 63),
      ))
    }

@delegate:ResourceContentHash(1_558_084_225)
internal val Res.string.users_import_profile: StringResource by lazy {
      StringResource("string:users_import_profile", "users_import_profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95457, 72),
      ))
    }

@delegate:ResourceContentHash(493_299_362)
internal val Res.string.users_import_profile_placeholder: StringResource by lazy {
      StringResource("string:users_import_profile_placeholder", "users_import_profile_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95388, 68),
      ))
    }

@delegate:ResourceContentHash(1_438_758_366)
internal val Res.string.users_import_result_title: StringResource by lazy {
      StringResource("string:users_import_result_title", "users_import_result_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95530, 69),
      ))
    }

@delegate:ResourceContentHash(-1_214_539_355)
internal val Res.string.users_import_skipped: StringResource by lazy {
      StringResource("string:users_import_skipped", "users_import_skipped", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95600, 132),
      ))
    }

@delegate:ResourceContentHash(-1_156_291_138)
internal val Res.string.users_import_title: StringResource by lazy {
      StringResource("string:users_import_title", "users_import_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95733, 50),
      ))
    }

@delegate:ResourceContentHash(-497_212_331)
internal val Res.string.users_inactive: StringResource by lazy {
      StringResource("string:users_inactive", "users_inactive", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95829, 34),
      ))
    }

@delegate:ResourceContentHash(-1_934_422_117)
internal val Res.string.users_manage_permissions: StringResource by lazy {
      StringResource("string:users_manage_permissions", "users_manage_permissions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95864, 60),
      ))
    }

@delegate:ResourceContentHash(871_979_899)
internal val Res.string.users_manage_profiles: StringResource by lazy {
      StringResource("string:users_manage_profiles", "users_manage_profiles", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95925, 53),
      ))
    }

@delegate:ResourceContentHash(127_127_642)
internal val Res.string.users_more_names: StringResource by lazy {
      StringResource("string:users_more_names", "users_more_names", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95979, 32),
      ))
    }

@delegate:ResourceContentHash(-1_703_357_867)
internal val Res.string.users_never: StringResource by lazy {
      StringResource("string:users_never", "users_never", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96012, 39),
      ))
    }

@delegate:ResourceContentHash(893_954_141)
internal val Res.string.users_none: StringResource by lazy {
      StringResource("string:users_none", "users_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96052, 26),
      ))
    }

@delegate:ResourceContentHash(-48_404_385)
internal val Res.string.users_only_active: StringResource by lazy {
      StringResource("string:users_only_active", "users_only_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96079, 45),
      ))
    }

@delegate:ResourceContentHash(-61_876_579)
internal val Res.string.users_permission_code: StringResource by lazy {
      StringResource("string:users_permission_code", "users_permission_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96125, 45),
      ))
    }

@delegate:ResourceContentHash(-1_560_339_433)
internal val Res.string.users_permission_edit_title: StringResource by lazy {
      StringResource("string:users_permission_edit_title", "users_permission_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96171, 59),
      ))
    }

@delegate:ResourceContentHash(-2_029_300_045)
internal val Res.string.users_permission_new: StringResource by lazy {
      StringResource("string:users_permission_new", "users_permission_new", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96231, 48),
      ))
    }

@delegate:ResourceContentHash(1_474_093_055)
internal val Res.string.users_permission_profiles: StringResource by lazy {
      StringResource("string:users_permission_profiles", "users_permission_profiles", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96280, 85),
      ))
    }

@delegate:ResourceContentHash(-385_758_906)
internal val Res.string.users_permission_remove: StringResource by lazy {
      StringResource("string:users_permission_remove", "users_permission_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96632, 55),
      ))
    }

@delegate:ResourceContentHash(550_496_829)
internal val Res.string.users_permission_remove_confirm: StringResource by lazy {
      StringResource("string:users_permission_remove_confirm", "users_permission_remove_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96366, 51),
      ))
    }

@delegate:ResourceContentHash(-1_812_189_962)
internal val Res.string.users_permission_remove_msg: StringResource by lazy {
      StringResource("string:users_permission_remove_msg", "users_permission_remove_msg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96418, 151),
      ))
    }

@delegate:ResourceContentHash(-385_758_906)
internal val Res.string.users_permission_remove_title: StringResource by lazy {
      StringResource("string:users_permission_remove_title", "users_permission_remove_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96570, 61),
      ))
    }

@delegate:ResourceContentHash(581_300_450)
internal val Res.string.users_permissions_empty: StringResource by lazy {
      StringResource("string:users_permissions_empty", "users_permissions_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96688, 71),
      ))
    }

@delegate:ResourceContentHash(-114_784_899)
internal val Res.string.users_permissions_title: StringResource by lazy {
      StringResource("string:users_permissions_title", "users_permissions_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96760, 47),
      ))
    }

@delegate:ResourceContentHash(-1_747_126_949)
internal val Res.string.users_profile_form_add_title: StringResource by lazy {
      StringResource("string:users_profile_form_add_title", "users_profile_form_add_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96808, 52),
      ))
    }

@delegate:ResourceContentHash(-889_076_991)
internal val Res.string.users_profile_form_edit_title: StringResource by lazy {
      StringResource("string:users_profile_form_edit_title", "users_profile_form_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96861, 57),
      ))
    }

@delegate:ResourceContentHash(-1_324_232_961)
internal val Res.string.users_profile_name: StringResource by lazy {
      StringResource("string:users_profile_name", "users_profile_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96919, 46),
      ))
    }

@delegate:ResourceContentHash(-1_747_126_949)
internal val Res.string.users_profile_new: StringResource by lazy {
      StringResource("string:users_profile_new", "users_profile_new", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96966, 41),
      ))
    }

@delegate:ResourceContentHash(1_581_064_280)
internal val Res.string.users_profile_no_permissions: StringResource by lazy {
      StringResource("string:users_profile_no_permissions", "users_profile_no_permissions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97008, 56),
      ))
    }

@delegate:ResourceContentHash(1_375_343_523)
internal val Res.string.users_profile_none: StringResource by lazy {
      StringResource("string:users_profile_none", "users_profile_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97065, 42),
      ))
    }

@delegate:ResourceContentHash(-114_784_899)
internal val Res.string.users_profile_permissions: StringResource by lazy {
      StringResource("string:users_profile_permissions", "users_profile_permissions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97108, 49),
      ))
    }

@delegate:ResourceContentHash(-2_096_082_831)
internal val Res.string.users_profile_remove: StringResource by lazy {
      StringResource("string:users_profile_remove", "users_profile_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97439, 48),
      ))
    }

@delegate:ResourceContentHash(550_496_829)
internal val Res.string.users_profile_remove_confirm: StringResource by lazy {
      StringResource("string:users_profile_remove_confirm", "users_profile_remove_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97158, 48),
      ))
    }

@delegate:ResourceContentHash(-2_015_959_112)
internal val Res.string.users_profile_remove_msg: StringResource by lazy {
      StringResource("string:users_profile_remove_msg", "users_profile_remove_msg", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97207, 176),
      ))
    }

@delegate:ResourceContentHash(-2_096_082_831)
internal val Res.string.users_profile_remove_title: StringResource by lazy {
      StringResource("string:users_profile_remove_title", "users_profile_remove_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97384, 54),
      ))
    }

@delegate:ResourceContentHash(-828_907_649)
internal val Res.string.users_profiles_empty: StringResource by lazy {
      StringResource("string:users_profiles_empty", "users_profiles_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97488, 64),
      ))
    }

@delegate:ResourceContentHash(-385_796_497)
internal val Res.string.users_profiles_title: StringResource by lazy {
      StringResource("string:users_profiles_title", "users_profiles_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97553, 52),
      ))
    }

@delegate:ResourceContentHash(-989_284_405)
internal val Res.string.users_retry: StringResource by lazy {
      StringResource("string:users_retry", "users_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97606, 43),
      ))
    }

@delegate:ResourceContentHash(1_353_865_830)
internal val Res.string.users_save: StringResource by lazy {
      StringResource("string:users_save", "users_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97650, 26),
      ))
    }

@delegate:ResourceContentHash(-551_094_829)
internal val Res.string.users_search_placeholder: StringResource by lazy {
      StringResource("string:users_search_placeholder", "users_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97677, 84),
      ))
    }

@delegate:ResourceContentHash(-2_075_471_954)
internal val Res.string.users_title: StringResource by lazy {
      StringResource("string:users_title", "users_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97762, 31),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString13Resources(map: MutableMap<String, StringResource>) {
  map.put("rmp_type_requisicao", Res.string.rmp_type_requisicao)
  map.put("rmp_type_requisicao_teste", Res.string.rmp_type_requisicao_teste)
  map.put("rmp_type_termino_contrato", Res.string.rmp_type_termino_contrato)
  map.put("rmp_type_transferencia", Res.string.rmp_type_transferencia)
  map.put("rmp_unit_rules", Res.string.rmp_unit_rules)
  map.put("rmp_unit_rules_hint", Res.string.rmp_unit_rules_hint)
  map.put("rmp_unit_rules_only_marked", Res.string.rmp_unit_rules_only_marked)
  map.put("rmp_unit_rules_search", Res.string.rmp_unit_rules_search)
  map.put("rmp_unit_rules_title", Res.string.rmp_unit_rules_title)
  map.put("rmp_unit_rules_waives_ceo", Res.string.rmp_unit_rules_waives_ceo)
  map.put("shell_filters", Res.string.shell_filters)
  map.put("slogan", Res.string.slogan)
  map.put("users_action_activate", Res.string.users_action_activate)
  map.put("users_action_create", Res.string.users_action_create)
  map.put("users_action_deactivate", Res.string.users_action_deactivate)
  map.put("users_action_details", Res.string.users_action_details)
  map.put("users_action_edit", Res.string.users_action_edit)
  map.put("users_action_view", Res.string.users_action_view)
  map.put("users_active", Res.string.users_active)
  map.put("users_add", Res.string.users_add)
  map.put("users_cancel", Res.string.users_cancel)
  map.put("users_col_actions", Res.string.users_col_actions)
  map.put("users_col_company", Res.string.users_col_company)
  map.put("users_col_email", Res.string.users_col_email)
  map.put("users_col_full_name", Res.string.users_col_full_name)
  map.put("users_col_last_access", Res.string.users_col_last_access)
  map.put("users_col_phone", Res.string.users_col_phone)
  map.put("users_col_role", Res.string.users_col_role)
  map.put("users_col_sector", Res.string.users_col_sector)
  map.put("users_col_status", Res.string.users_col_status)
  map.put("users_col_updated_at", Res.string.users_col_updated_at)
  map.put("users_col_updated_by", Res.string.users_col_updated_by)
  map.put("users_company_hint", Res.string.users_company_hint)
  map.put("users_deactivate_confirm", Res.string.users_deactivate_confirm)
  map.put("users_deactivate_msg", Res.string.users_deactivate_msg)
  map.put("users_deactivate_title", Res.string.users_deactivate_title)
  map.put("users_details_title", Res.string.users_details_title)
  map.put("users_empty", Res.string.users_empty)
  map.put("users_export", Res.string.users_export)
  map.put("users_field_email", Res.string.users_field_email)
  map.put("users_field_full_name", Res.string.users_field_full_name)
  map.put("users_field_new_password", Res.string.users_field_new_password)
  map.put("users_field_permissions", Res.string.users_field_permissions)
  map.put("users_field_phone", Res.string.users_field_phone)
  map.put("users_field_profile", Res.string.users_field_profile)
  map.put("users_field_role", Res.string.users_field_role)
  map.put("users_field_sector", Res.string.users_field_sector)
  map.put("users_form_add_title", Res.string.users_form_add_title)
  map.put("users_form_edit_title", Res.string.users_form_edit_title)
  map.put("users_go_to_org_chart", Res.string.users_go_to_org_chart)
  map.put("users_import", Res.string.users_import)
  map.put("users_import_created", Res.string.users_import_created)
  map.put("users_import_duplicates", Res.string.users_import_duplicates)
  map.put("users_import_error", Res.string.users_import_error)
  map.put("users_import_loaded", Res.string.users_import_loaded)
  map.put("users_import_pick", Res.string.users_import_pick)
  map.put("users_import_previewing", Res.string.users_import_previewing)
  map.put("users_import_profile", Res.string.users_import_profile)
  map.put("users_import_profile_placeholder", Res.string.users_import_profile_placeholder)
  map.put("users_import_result_title", Res.string.users_import_result_title)
  map.put("users_import_skipped", Res.string.users_import_skipped)
  map.put("users_import_title", Res.string.users_import_title)
  map.put("users_inactive", Res.string.users_inactive)
  map.put("users_manage_permissions", Res.string.users_manage_permissions)
  map.put("users_manage_profiles", Res.string.users_manage_profiles)
  map.put("users_more_names", Res.string.users_more_names)
  map.put("users_never", Res.string.users_never)
  map.put("users_none", Res.string.users_none)
  map.put("users_only_active", Res.string.users_only_active)
  map.put("users_permission_code", Res.string.users_permission_code)
  map.put("users_permission_edit_title", Res.string.users_permission_edit_title)
  map.put("users_permission_new", Res.string.users_permission_new)
  map.put("users_permission_profiles", Res.string.users_permission_profiles)
  map.put("users_permission_remove", Res.string.users_permission_remove)
  map.put("users_permission_remove_confirm", Res.string.users_permission_remove_confirm)
  map.put("users_permission_remove_msg", Res.string.users_permission_remove_msg)
  map.put("users_permission_remove_title", Res.string.users_permission_remove_title)
  map.put("users_permissions_empty", Res.string.users_permissions_empty)
  map.put("users_permissions_title", Res.string.users_permissions_title)
  map.put("users_profile_form_add_title", Res.string.users_profile_form_add_title)
  map.put("users_profile_form_edit_title", Res.string.users_profile_form_edit_title)
  map.put("users_profile_name", Res.string.users_profile_name)
  map.put("users_profile_new", Res.string.users_profile_new)
  map.put("users_profile_no_permissions", Res.string.users_profile_no_permissions)
  map.put("users_profile_none", Res.string.users_profile_none)
  map.put("users_profile_permissions", Res.string.users_profile_permissions)
  map.put("users_profile_remove", Res.string.users_profile_remove)
  map.put("users_profile_remove_confirm", Res.string.users_profile_remove_confirm)
  map.put("users_profile_remove_msg", Res.string.users_profile_remove_msg)
  map.put("users_profile_remove_title", Res.string.users_profile_remove_title)
  map.put("users_profiles_empty", Res.string.users_profiles_empty)
  map.put("users_profiles_title", Res.string.users_profiles_title)
  map.put("users_retry", Res.string.users_retry)
  map.put("users_save", Res.string.users_save)
  map.put("users_search_placeholder", Res.string.users_search_placeholder)
  map.put("users_title", Res.string.users_title)
}
